import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import FolderIcon from '@material-ui/icons/Folder';
import RestoreIcon from '@material-ui/icons/Restore';
import HomeIcon from '@material-ui/icons/Home';
import FavoriteIcon from '@material-ui/icons/Favorite';
import CameraIcon from '@material-ui/icons/Camera';

import { useStyles } from './navMenuStyle';

export default function NavMenu() {
  const classes = useStyles();
  const location = useLocation();
  const pathname = location.pathname;

  const [value, setValue] = React.useState(pathname);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      lazy="false"
      showLabels={true}
      className={classes.root}
    >
      <BottomNavigationAction
        label="Recent"
        value="recent"
        icon={<RestoreIcon />}
        component={Link}
        to="/recent"
      />

      <BottomNavigationAction
        label="Camera"
        value="capture"
        icon={<CameraIcon />}
        component={Link}
        to="/capture"
      />

      <BottomNavigationAction
        label="Home"
        value="/"
        icon={<HomeIcon />}
        component={Link}
        to="/"
      />

      <BottomNavigationAction
        label="Favorites"
        value="favorites"
        icon={<FavoriteIcon />}
        component={Link}
        to="/favorite"
      />

      <BottomNavigationAction
        label="Documents"
        value="documents"
        icon={<FolderIcon />}
        component={Link}
        to="/docs"
      />
    </BottomNavigation>
  );
}
